import { DEFAULT_SMOOTHING_ALGORITHM, type SmoothingAlgorithm } from './smoothing-algorithm';

export type SmoothingConfig = {
  smoothing?: number;
  smoothingAlgorithm?: SmoothingAlgorithm;
  showOriginalLineOnSmoothing?: boolean;
};

export const DEFAULT_SMOOTHING_CONFIG: SmoothingConfig = {
  smoothing: undefined,
  smoothingAlgorithm: DEFAULT_SMOOTHING_ALGORITHM,
  showOriginalLineOnSmoothing: true,
};

export function isDefaultSmoothingConfig({
  smoothing,
  smoothingAlgorithm,
  showOriginalLineOnSmoothing,
}: SmoothingConfig): boolean {
  return (
    smoothing === DEFAULT_SMOOTHING_CONFIG.smoothing &&
    (smoothingAlgorithm === undefined ||
      smoothingAlgorithm === DEFAULT_SMOOTHING_CONFIG.smoothingAlgorithm) &&
    (showOriginalLineOnSmoothing === undefined ||
      showOriginalLineOnSmoothing === DEFAULT_SMOOTHING_CONFIG.showOriginalLineOnSmoothing)
  );
}

export function hasLocalSmoothingOverrides({
  smoothing,
  smoothingAlgorithm,
  showOriginalLineOnSmoothing,
}: SmoothingConfig): boolean {
  return (
    smoothing !== undefined ||
    smoothingAlgorithm !== undefined ||
    showOriginalLineOnSmoothing !== undefined
  );
}
